import { render, staticRenderFns } from "./PxProgressBars.vue?vue&type=template&id=20bc3df2&"
import script from "./PxProgressBars.vue?vue&type=script&lang=js&"
export * from "./PxProgressBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports